import { useMemo } from 'react'

import config from '@app/config'
import { ConversationItem, MessageItem } from '@app/models'

import { useConversationLanguage } from './conversation/useConversationLanguage'
import { useUser } from './user/useUser'

export const useTranslatedMessage = (
  message: MessageItem,
  conversation: ConversationItem
) => {
  const user = useUser()
  const { isTranslationEnabled } = useConversationLanguage(conversation)

  const messageUserId = useMemo(() => {
    const messageParticipant = conversation.participants.find(
      (participant) => participant.id === message.fromParticipantId
    )

    return messageParticipant?.userId
  }, [conversation.participants, message.fromParticipantId])

  return useMemo(() => {
    if (
      !isTranslationEnabled ||
      !message?.translations ||
      messageUserId === user.currentUser.id
    ) {
      return message.content?.text
    }

    const translation = message.translations.find(
      (item) => item.language === config.regionalSettings?.language
    )
    if (!translation) {
      return message.content?.text
    }

    return translation.text
  }, [message, isTranslationEnabled, config.regionalSettings?.language])
}
